/**
 * Passwort vergessen – /forgot-password
 *
 * Design: Terminal-UI, Dark-Theme, Share Tech Mono.
 * WICHTIG: Immer gleiche Erfolgs-/Fehlermeldung anzeigen (verhindert User-Enumeration).
 */

import { api } from '../services/api.js';

export function renderForgotPassword(): void {
  const app = document.getElementById('app');
  if (!app) return;

  app.innerHTML = `
    <main class="auth-page">
      <div class="auth-card">
        <p class="auth-brand">▶ NIGHTTRADE</p>
        <h1 class="auth-title">Passwort zurücksetzen</h1>
        <p class="auth-subtitle">Gib deine E-Mail-Adresse ein. Falls ein Account existiert, erhältst du einen Reset-Link.</p>

        <form id="forgot-form" novalidate>
          <div class="form-group">
            <label for="forgot-email">E-Mail-Adresse</label>
            <input
              type="email"
              id="forgot-email"
              name="email"
              autocomplete="email"
              required
              placeholder="spieler@beispiel.de"
            />
          </div>

          <div
            id="forgot-error"
            class="form-error"
            role="alert"
            aria-live="polite"
            hidden
          ></div>

          <div
            id="forgot-success"
            class="form-success"
            role="status"
            aria-live="polite"
            hidden
          ></div>

          <button type="submit" id="forgot-submit" class="primary btn-full">
            Reset-Link anfordern
          </button>
        </form>

        <nav class="auth-links">
          <a href="/login">&#8592; Zurück zum Login</a>
        </nav>
      </div>
    </main>
  `;

  const form = document.getElementById('forgot-form') as HTMLFormElement | null;
  const emailInput = document.getElementById('forgot-email') as HTMLInputElement | null;
  const submitBtn = document.getElementById('forgot-submit') as HTMLButtonElement | null;
  const errorDiv = document.getElementById('forgot-error') as HTMLDivElement | null;
  const successDiv = document.getElementById('forgot-success') as HTMLDivElement | null;

  if (!form || !emailInput || !submitBtn || !errorDiv || !successDiv) return;

  function showError(message: string): void {
    if (!errorDiv) return;
    errorDiv.textContent = message;
    errorDiv.hidden = false;
    if (successDiv) successDiv.hidden = true;
  }

  function showSuccess(message: string): void {
    if (!successDiv) return;
    successDiv.textContent = message;
    successDiv.hidden = false;
    if (errorDiv) errorDiv.hidden = true;
    // Formular ausblenden – verhindert doppeltes Absenden
    if (form) form.hidden = true;
  }

  function setLoading(loading: boolean): void {
    if (!submitBtn) return;
    submitBtn.disabled = loading;
    submitBtn.textContent = loading ? '■ WIRD VERARBEITET...' : 'Reset-Link anfordern';
    submitBtn.setAttribute('aria-busy', String(loading));
  }

  form.addEventListener('submit', (event: Event): void => {
    event.preventDefault();
    errorDiv.hidden = true;

    const email = emailInput.value.trim();
    if (!email) {
      showError('Bitte E-Mail-Adresse eingeben.');
      return;
    }

    setLoading(true);

    void (async (): Promise<void> => {
      try {
        // CSRF nicht nötig: forgot-password ist ein POST ohne Session
        // fetchApi sendet CSRF nur wenn csrfToken in gameState vorhanden ist
        await api.post<{ message: string }>('/auth/forgot-password', { email });
        // Immer gleiche Meldung – Backend gibt ebenfalls neutrale Response zurück
        showSuccess('Falls ein Account mit dieser E-Mail existiert, wurde ein Reset-Link versendet. Bitte prüfe dein Postfach.');
      } catch {
        // Auch bei Fehler: neutrale Meldung (verhindert User-Enumeration)
        showSuccess('Falls ein Account mit dieser E-Mail existiert, wurde ein Reset-Link versendet. Bitte prüfe dein Postfach.');
      } finally {
        setLoading(false);
      }
    })();
  });
}
